import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _extends from "@babel/runtime/helpers/extends";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { findOverflowedParent, getBoundingClientRect as originalGetBoundingClientRect } from '../utils/DOM';
import { withStyles } from '../theme';
import { POINTS_X, POINTS_Y, MAPPING_POINTS } from '../constants/overlay';
import classnames from 'classnames';
import EventEmitter from 'eventemitter3';

var noop = function noop() {};
/**
 * Получить опции позиции контента
 * @param  {Object}  params       -
 * @param  {Object}  params.anchorRect    - объект с полями {left, right, top, bottom}
 * @param  {Object}  params.parentRect    - объект с полями {left, right, top, bottom}
 * @param  {Number}  params.contentHeight - высота элемента с контентом
 * @param  {Number}  params.contentWidth  - ширина элемента с контентом
 * @param  {String}  params.anchorPointX  - точка прикрепления
 * @param  {String}  params.anchorPointY  - точка прикрепления
 * @param  {String}  params.contentPointX - точка прикрепления
 * @param  {String}  params.contentPointY - точка прикрепления
 * @param  {Boolean} params.autoPositionX - автопозиционирование по оси X
 * @param  {Boolean} params.autoPositionY - автопозиционирование по оси Y
 * @param  {Boolean} params.noRecalculate - не пересчитывать
 * @return {Object}
 */


function getPositionOptions(params) {
  var anchorRect = params.anchorRect,
      parentRect = params.parentRect,
      contentHeight = params.contentHeight,
      contentWidth = params.contentWidth,
      anchorPointX = params.anchorPointX,
      anchorPointY = params.anchorPointY,
      autoPositionX = params.autoPositionX,
      autoPositionY = params.autoPositionY,
      noRecalculate = params.noRecalculate,
      windowSize = params.windowSize;
  var contentPointX = params.contentPointX,
      contentPointY = params.contentPointY;
  var left,
      right,
      top,
      bottom,
      translateX = '0%',
      translateY = '0%',
      overflowX = 0,
      overflowY = 0;
  var newAnchorPointX, newAnchorPointY;

  if (contentPointX === 'left') {
    if (anchorPointX === 'left') {
      left = '0%';
      if (autoPositionX) overflowX = anchorRect.left + contentWidth - parentRect.right;
    } else if (anchorPointX === 'center') {
      left = '50%';
      if (autoPositionX) overflowX = anchorRect.left + anchorRect.width / 2 + contentWidth - parentRect.right;
    } else if (anchorPointX === 'right') {
      left = '100%';
      if (autoPositionX) overflowX = anchorRect.right + contentWidth - parentRect.right;
    }
  } else if (contentPointX === 'center') {
    translateX = '-50%';

    if (anchorPointX === 'left') {
      left = '0%';
      if (autoPositionX) overflowX = parentRect.left - (anchorRect.left - contentWidth / 2);
    } else if (anchorPointX === 'center') {
      left = '50%';

      if (autoPositionX) {
        var overflowXLeft = parentRect.left - (anchorRect.left + anchorRect.width / 2 - contentWidth / 2);
        var overflowXRight = anchorRect.left + anchorRect.width / 2 + contentWidth / 2 - parentRect.right;
        overflowX = Math.max(overflowXRight, overflowXLeft);
        newAnchorPointX = overflowXLeft > overflowXRight ? 'left' : 'right';
      }
    } else if (anchorPointX === 'right') {
      left = '100%';
      if (autoPositionX) overflowX = anchorRect.right + contentWidth / 2 - parentRect.right;
    }
  } else if (contentPointX === 'right') {
    if (anchorPointX === 'left') {
      right = '100%';
      if (autoPositionX) overflowX = parentRect.left - (anchorRect.left - contentWidth);
    } else if (anchorPointX === 'center') {
      right = '50%';
      if (autoPositionX) overflowX = parentRect.left - (anchorRect.left - contentWidth + anchorRect.width / 2);
    } else if (anchorPointX === 'right') {
      right = '0%';
      if (autoPositionX) overflowX = parentRect.left - (anchorRect.right - contentWidth);
    }
  }

  if (contentPointY === 'top') {
    if (anchorPointY === 'top') {
      top = '0%';

      if (autoPositionY) {
        overflowY = anchorRect.top + contentHeight - parentRect.bottom;
        if (overflowY < 0) overflowY = anchorRect.top + contentHeight - windowSize.height;
      }
    } else if (anchorPointY === 'center') {
      top = '50%';

      if (autoPositionY) {
        overflowY = anchorRect.top + anchorRect.height / 2 + contentHeight - parentRect.bottom;
        if (overflowY < 0) overflowY = anchorRect.top + anchorRect.height / 2 + contentHeight - windowSize.height;
      }
    } else if (anchorPointY === 'bottom') {
      top = '100%';

      if (autoPositionY) {
        overflowY = anchorRect.bottom + contentHeight - parentRect.bottom;
        if (overflowY < 0) overflowY = anchorRect.bottom + contentHeight - windowSize.height;
      }
    }
  } else if (contentPointY === 'center') {
    translateY = '-50%';

    if (anchorPointY === 'top') {
      top = '0%';

      if (autoPositionY) {
        overflowY = parentRect.top - (anchorRect.top - contentHeight / 2);
        if (overflowY < 0) overflowY = anchorRect.top - contentHeight / 2;
      }
    } else if (anchorPointY === 'center') {
      top = '50%';

      if (autoPositionX) {
        var overflowXTop = parentRect.top - (anchorRect.top + anchorRect.height / 2 - contentHeight / 2);
        var overflowXBottom = anchorRect.top + anchorRect.height / 2 + contentHeight / 2 - parentRect.bottom;
        overflowY = Math.max(overflowXTop, overflowXBottom);
        newAnchorPointY = overflowXTop > overflowXBottom ? 'top' : 'right';
      }
    } else if (anchorPointY === 'bottom') {
      top = '100%';

      if (autoPositionY) {
        overflowY = anchorRect.bottom + contentHeight / 2 - parentRect.bottom;
        if (overflowY < 0) overflowY = anchorRect.bottom + contentHeight / 2 - windowSize.height;
      }
    }
  } else if (contentPointY === 'bottom') {
    if (anchorPointY === 'top') {
      bottom = '100%';

      if (autoPositionY) {
        overflowY = parentRect.top - (anchorRect.top - contentHeight);
        if (overflowY < 0) overflowY = contentHeight - anchorRect.top;
      }
    } else if (anchorPointY === 'center') {
      bottom = '50%';

      if (autoPositionY) {
        overflowY = parentRect.top - (anchorRect.top + anchorRect.height / 2 - contentHeight);
        if (overflowY < 0) overflowY = contentHeight - (anchorRect.top + anchorRect.height / 2);
      }
    } else if (anchorPointY === 'bottom') {
      bottom = '0%';

      if (autoPositionY) {
        overflowY = parentRect.top - (anchorRect.bottom - contentHeight);
        if (overflowY < 0) overflowY = contentHeight - anchorRect.bottom;
      }
    }
  }

  if (!noRecalculate) {
    if (autoPositionX && overflowX > 0) {
      var result = getPositionOptions(_extends({}, params, {
        anchorPointX: newAnchorPointX || MAPPING_POINTS[anchorPointX],
        contentPointX: newAnchorPointX || MAPPING_POINTS[contentPointX],
        noRecalculate: true
      }));

      if (result.overflowX < overflowX) {
        left = result.left;
        right = result.right;
        translateX = result.translateX;
        overflowX = result.overflowX;
        contentPointX = result.contentPointX;
      }
    }

    if (autoPositionY && overflowY > 0) {
      var newParams = _extends({}, params, {
        anchorPointY: newAnchorPointY || MAPPING_POINTS[anchorPointY],
        contentPointY: newAnchorPointY || MAPPING_POINTS[contentPointY],
        noRecalculate: true
      });

      var _result = getPositionOptions(newParams);

      if (_result.overflowY < overflowY) {
        top = _result.top;
        bottom = _result.bottom;
        translateY = _result.translateY;
        overflowY = _result.overflowY;
        contentPointY = _result.contentPointY;
      }
    }
  }

  return {
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    translateX: translateX,
    translateY: translateY,
    contentPointX: contentPointX,
    contentPointY: contentPointY,
    overflowX: overflowX,
    overflowY: overflowY
  };
}

function getContentProps(params) {
  var _getPositionOptions = getPositionOptions(params),
      left = _getPositionOptions.left,
      right = _getPositionOptions.right,
      top = _getPositionOptions.top,
      bottom = _getPositionOptions.bottom,
      translateX = _getPositionOptions.translateX,
      translateY = _getPositionOptions.translateY,
      contentPointX = _getPositionOptions.contentPointX,
      contentPointY = _getPositionOptions.contentPointY,
      anchorPointY = _getPositionOptions.anchorPointY,
      anchorPointX = _getPositionOptions.anchorPointX;

  return {
    anchorPointY: anchorPointY,
    anchorPointX: anchorPointX,
    style: {
      left: left,
      right: right,
      top: top,
      bottom: bottom,
      transform: "translate(".concat(translateX, ", ").concat(translateY, ")")
    },
    pointX: contentPointX,
    pointY: contentPointY
  };
}

var styles = {
  container: {
    position: 'relative',
    display: 'inline-block'
  },
  content: {
    position: 'absolute',
    zIndex: 10
  }
};
/**
 * Оверлей, который оборачивает внутри children, и позиционируется относительно children рядом с ними
 */

var RelativeOverlay = /*#__PURE__*/function (_PureComponent) {
  _inherits(RelativeOverlay, _PureComponent);

  var _super = _createSuper(RelativeOverlay);

  function RelativeOverlay() {
    var _this;

    _classCallCheck(this, RelativeOverlay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.events = new EventEmitter();
    _this.transactionIndex = 0;
    _this.state = {
      /**
       * Вставлен ли контент в DOM
       */
      isContentInDom: _this.props.isOpened || false,

      /**
       * является ли content видимым
       */
      isContentVisible: false,

      /**
       * Точка прикрепления контента X
       */
      contentPointX: _this.props.contentPointX,

      /**
       * Точка прикрепления контента Y
       */
      contentPointY: _this.props.contentPointY,

      /**
       * Точка прицепления для achor X
       */
      anchorPointX: _this.props.anchorPointX,

      /**
       * Точка прицепления для achor Y
       */
      anchorPointY: _this.props.anchorPointY,

      /**
       * Ширина anchor элемента
       */
      anchorWidth: undefined,

      /**
       * Высота anchor элемента
       */
      anchorHeight: undefined,

      /**
       * Координата anchor по оси X
       */
      anchorLeft: undefined,

      /**
       * Координата anchor по оси Y
       */
      anchorTop: undefined,

      /**
       * Стиль контента
       */
      contentStyle: {}
    };

    _this.onContentBecomeVisible = function () {
      _this.events.emit('contentVisible');
    };

    _this.onContentBecomeInvisible = function () {
      _this.events.emit('contentInvisible');
    };

    _this.onContentMount = function (element) {
      _this.contentElement = element;

      _this.updateContentPosition();
    };

    _this.onContainerMount = function (element) {
      _this.containerElement = element;
    };

    _this.hide = function () {
      if (!_this.contentElement) return;
      var transactionIndex = ++_this.transactionIndex;

      _this.setState({
        isContentVisible: false
      });

      return new Promise(function (resolve) {
        var handler = function handler() {
          if (transactionIndex === _this.transactionIndex) _this.setState({
            isContentInDom: false
          }, resolve);
          if (transactionIndex <= _this.transactionIndex) _this.events.removeListener('contentInvisible', handler); // if (transactionIndex < this.transactionIndex)
          //   reject()
        };

        _this.events.on('contentInvisible', handler);
      }).then(function () {
        if (_this.props.onContentClose) _this.props.onContentClose();
      });
    };

    return _this;
  }

  _createClass(RelativeOverlay, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          isOpened = _this$props.isOpened,
          anchorPointX = _this$props.anchorPointX,
          anchorPointY = _this$props.anchorPointY,
          contentPointX = _this$props.contentPointX,
          contentPointY = _this$props.contentPointY;
      if (isOpened !== undefined && isOpened !== prevProps.isOpened) {
        if (isOpened) this.show();else this.hide();
      } else if (isOpened && (prevProps.anchorPointX !== anchorPointX || prevProps.anchorPointY !== anchorPointY || prevProps.contentPointX !== contentPointX || prevProps.contentPointY !== contentPointY)) this.show();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.events.removeAllListeners();
      this.contentElement = null;
      this.containerElement = null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpened) this.show();
    }
    /**
     * Вызывается когда контент показан
     */

  }, {
    key: "updateContentPosition",

    /**
     * Вычислить позицию
     */
    value: function updateContentPosition() {
      if (!this.state.isContentInDom || !this.contentElement) return; // Вычисляем новый contentPoint, если нужно, в зависимости от ширины и высоты contentElement

      var _this$props2 = this.props,
          anchorPointX = _this$props2.anchorPointX,
          anchorPointY = _this$props2.anchorPointY,
          contentPointX = _this$props2.contentPointX,
          contentPointY = _this$props2.contentPointY,
          autoPositionX = _this$props2.autoPositionX,
          autoPositionY = _this$props2.autoPositionY,
          getWindowSize = _this$props2.getWindowSize,
          getElementRect = _this$props2.getElementRect;
      var parent = findOverflowedParent(this.containerElement, true);
      var anchorRect = getElementRect(this.containerElement);
      var parentRect = getElementRect(parent);
      var contentProps = getContentProps({
        anchorRect: anchorRect,
        parentRect: parentRect,
        anchorPointX: anchorPointX,
        anchorPointY: anchorPointY,
        contentPointX: contentPointX,
        contentPointY: contentPointY,
        autoPositionX: autoPositionX,
        autoPositionY: autoPositionY,
        contentHeight: this.contentElement.offsetHeight,
        contentWidth: this.contentElement.offsetWidth,
        windowSize: getWindowSize()
      });
      this.events.emit('newContentPosition', contentProps);
    }
    /**
     * Показать оверлей
     */

  }, {
    key: "show",
    value: function show() {
      var _this2 = this;

      var transactionIndex = ++this.transactionIndex;
      this.setState({
        isContentInDom: true
      });
      var whenPositioned = new Promise(function (resolve, reject) {
        var handler = function handler(result) {
          if (transactionIndex === _this2.transactionIndex) resolve(result);
          if (transactionIndex <= _this2.transactionIndex) _this2.events.removeListener('newContentPosition', handler);
          if (transactionIndex < _this2.transactionIndex) reject();
        };

        _this2.events.on('newContentPosition', handler);

        _this2.updateContentPosition();
      });
      whenPositioned.then(function (_ref) {
        var style = _ref.style,
            pointX = _ref.pointX,
            pointY = _ref.pointY,
            anchorPointX = _ref.anchorPointX,
            anchorPointY = _ref.anchorPointY;

        var anchorRect = _this2.props.getElementRect(_this2.containerElement);

        _this2.setState({
          anchorPointX: anchorPointX,
          anchorPointY: anchorPointY,
          contentStyle: style,
          contentPointX: pointX,
          contentPointY: pointY,
          anchorWidth: anchorRect.width,
          anchorHeight: anchorRect.height,
          anchorLeft: anchorRect.left,
          anchorTop: anchorRect.top,
          isContentVisible: true
        });
      });
      var whenVisible = new Promise(function (resolve) {
        var handler = function handler() {
          if (transactionIndex === _this2.transactionIndex) resolve();
          if (transactionIndex <= _this2.transactionIndex) _this2.events.removeListener('contentVisible', handler); // if (transactionIndex < this.transactionIndex)
          //   reject()
        };

        _this2.events.on('contentVisible', handler);
      });
      return Promise.all([whenPositioned, whenVisible]).then(function () {
        if (_this2.props.onContentOpen) _this2.props.onContentOpen();
      }).catch(noop);
    }
    /**
     * Скрыть оверлей
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          style = _this$props3.style,
          anchor = _this$props3.anchor,
          content = _this$props3.content,
          classes = _this$props3.classes;
      var _this$state = this.state,
          isContentVisible = _this$state.isContentVisible,
          isContentInDom = _this$state.isContentInDom,
          contentPointX = _this$state.contentPointX,
          contentPointY = _this$state.contentPointY,
          anchorPointX = _this$state.anchorPointX,
          anchorPointY = _this$state.anchorPointY,
          anchorWidth = _this$state.anchorWidth,
          anchorHeight = _this$state.anchorHeight,
          anchorLeft = _this$state.anchorLeft,
          anchorTop = _this$state.anchorTop,
          contentStyle = _this$state.contentStyle;
      var contentElement = null;
      if (isContentInDom) contentElement = React.createElement("div", {
        className: classes.content,
        style: contentStyle,
        ref: this.onContentMount
      }, cloneElement(content, {
        anchorPointX: anchorPointX,
        anchorPointY: anchorPointY,
        anchorWidth: anchorWidth,
        anchorHeight: anchorHeight,
        anchorLeft: anchorLeft,
        anchorTop: anchorTop,
        isVisible: isContentVisible,
        pointX: contentPointX,
        pointY: contentPointY,
        onBecomeVisible: this.onContentBecomeVisible,
        onBecomeInvisible: this.onContentBecomeInvisible,
        hide: this.hide
      }));
      return React.createElement("div", {
        className: classnames(className, classes.container),
        style: style,
        ref: this.onContainerMount
      }, anchor(undefined, {
        anchorPointX: anchorPointX,
        anchorPointY: anchorPointY,
        contentPointX: contentPointX,
        contentPointY: contentPointY
      }), contentElement);
    }
  }]);

  return RelativeOverlay;
}(PureComponent);

RelativeOverlay.defaultProps = {
  getWindowSize: function getWindowSize() {
    return {
      width: document.body.clientWidth,
      height: window.innerHeight
    };
  },
  getElementRect: originalGetBoundingClientRect
};
RelativeOverlay.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Класс контейнера
   */
  className: PropTypes.string,

  /**
   * Стиль контейнера
   */
  style: PropTypes.object,

  /**
   * Флаг управления показом оверлея
   */
  isOpened: PropTypes.bool.isRequired,

  /**
   * Точка прицепления для achor X
   */
  anchorPointX: PropTypes.oneOf(POINTS_X).isRequired,

  /**
   * Точка прицепления для achor Y
   */
  anchorPointY: PropTypes.oneOf(POINTS_Y).isRequired,

  /**
   * Точка прицепления для overlay X
   */
  contentPointX: PropTypes.oneOf(POINTS_X).isRequired,

  /**
   * Точка прицепления для overlay Y
   */
  contentPointY: PropTypes.oneOf(POINTS_Y).isRequired,

  /**
   * Автоматическое позиционирование, если контент по оси X выходит за пределы scroll-контейнера
   */
  autoPositionX: PropTypes.bool,

  /**
   * Автоматическое позиционирование, если контент по оси Y выходит за пределы scroll-контейнера
   */
  autoPositionY: PropTypes.bool,

  /**
   * Функция, возвращающая элемент вокруг которого показываем overlay
   */
  anchor: PropTypes.func.isRequired,

  /**
   * Инстанс компонент контента
   * Получает автоматически на вход следующие props:
   * - isVisible: true/false
   * при изменении это props, content должен показаться, opacity должен смениться
   * если isVisible=true, а потом стал false, колбеки анимации должны отмениться
   * - pointX: точка присоединения overlay к anchor, в зависимости от этой опции на тултипе можно рисоваться стрелочка по разному
   * - pointY: точка присоединения overlay к anchor, в зависимости от этой опции на тултипе можно рисоваться стрелочка по разному
   * - anchorPointX: точка присоединения контента к anchor по оси X
   * - anchorPointY: точка присоединения контента к anchor по оси Y
   * - onBecomeVisible - колбек, который должен вызваться, когда контент стал видимым
   * - onBecomeInvisible - колбек, который должен вызваться, когда контент стал невидимым
   * - hide - функция, которая должна вызываться, если контент нужно закрыть
   * - anchorWidth: ширина anchor
   * - anchorHeight: высота anchor
   * - anchorLeft: координата anchor по оси X
   * - anchorTop: координата anchor по оси Y
   */
  content: PropTypes.node.isRequired,

  /**
   * Колбек, который дергается, когда контент закрыт
   */
  onContentClose: PropTypes.func,

  /**
   * Колбек, который дергается, когда контент открыт
   */
  onContentOpen: PropTypes.func,

  /**
   * Функция для получения размеров окно
   * Нужна для подсчета того, что элемента выходит за пределы окна, нужна исключительно для iframe
   */
  getWindowSize: PropTypes.func,

  /**
   * Функция для подсчета границ и размеров элемента
   * Нужна исключительно внутри iframe
   */
  getElementRect: PropTypes.func
} : {};
export default withStyles(styles, {
  name: 'RelativeOverlay'
})(RelativeOverlay);